export const sportsIntro = 'Sport is part of everyday life at King Edwards Academy. Every learner takes part, ' +
  'whatever their starting point, and our teams are coached to compete with the best in the province.'

export const sportingFields = [
  { id: 1, name: 'Football', desc: 'Full size pitch with boys and girls teams across all age groups.' },
  { id: 2, name: 'Netball', desc: 'Hard court netball with regular inter-house and inter-school fixtures.' },
  { id: 3, name: 'Basketball', desc: 'Outdoor court and coaching from junior to senior level.' },
  { id: 4, name: 'Volleyball', desc: 'Court volleyball played through the season by both boys and girls.' },
  { id: 5, name: 'Cricket', desc: 'Coaching and fixtures for learners at every level of experience.' },
  { id: 6, name: 'Rugby', desc: 'Contact and touch rugby with an emphasis on safety and technique.' },
  { id: 7, name: 'Athletics', desc: 'Track and field events building towards the annual inter-house gala.' },
  { id: 8, name: 'Tennis', desc: 'Court tennis coaching for beginners through to competitive players.' },
  { id: 9, name: 'Chess', desc: 'Competitive chess with learners representing the school at tournaments.' },
  { id: 10, name: 'Table Tennis', desc: 'Indoor table tennis available throughout the school week.' }
]

// Photographs of learners taking part in sport. Add entries as
// { id, image, caption } and the gallery renders automatically; while the list
// is empty the gallery section is hidden.
export const sportsGallery = []
